import { createStore } from 'vuex';
import { screening } from './modules/screening';
import { global } from './modules/global';
import { home } from './modules/home';

export default createStore({
  modules: {
    screening,
    global,
    home,
  },
});
